import React from "react";
import HomeContent from "../Components/HomeContent";

const Home = () => {
    return (
        <React.Fragment>
            <HomeContent />
        </React.Fragment>
    );
};

export default Home;